import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Header() {
  const navigate = useNavigate();
  const { authFetch, isAdmin, isClient, userData } = useAuth();
  const [navCollapsed, setNavCollapsed] = useState(true);
  const [signedDocsQuota, setSignedDocsQuota] = useState(null);
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 992;

  useEffect(() => {
    let cancelled = false;
    const loadQuota = async () => {
      try {
        const response = await authFetch('/api/v1/signed-docs/quota');
        if (cancelled) return;
        if (response.ok) {
          const data = await response.json();
          setSignedDocsQuota({
            purchased: data.purchased,
            used: data.used,
            remaining: data.remaining,
          });
        } else {
          setSignedDocsQuota(null);
        }
      } catch {
        if (!cancelled) setSignedDocsQuota(null);
      }
    };
    loadQuota();
    return () => {
      cancelled = true;
    };
  }, [authFetch]);

  const handleLogout = async () => {
    try {
      await authFetch('/api/v1/logout', {
        method: 'POST'
      });
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('userData');
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const handleNavLinkClick = () => {
    if (window.innerWidth < 992) setNavCollapsed(true);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-custom">
      <div className="container">
        <Link className="navbar-brand navbar-brand-custom" to="/">
          Просто Подпиши
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={!navCollapsed}
          aria-label="Toggle navigation"
          onClick={() => setNavCollapsed((prev) => !prev)}
        >
          <span className="navbar-toggler-icon navbar-toggler-icon-custom"></span>
        </button>
        <div className={`collapse navbar-collapse${navCollapsed ? '' : ' show'}`} id="navbarNav">
          <ul className={`navbar-nav me-auto${isMobile ? ' gap-2 flex-column align-items-stretch' : ''}`}>
            <li className="nav-item">
              <Link className="nav-link nav-link-custom" to="/" onClick={handleNavLinkClick}>Главная</Link>
            </li>
            
            {/* Admin-only navigation items */}
            {isAdmin() && (
              <>
                <li className="nav-item">
                  <Link className="nav-link nav-link-custom" to="/template-docs" onClick={handleNavLinkClick}>Шаблоны документов</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link nav-link-custom" to="/offices" onClick={handleNavLinkClick}>Офисы</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link nav-link-custom" to="/upload-sign-doc" onClick={handleNavLinkClick}>Загрузить документ</Link>
                </li>
              </>
            )}
            
            {/* Client-only navigation items */}
            {isClient() && (
              <>
                <li className="nav-item">
                  <Link className="nav-link nav-link-custom" to="/launches" onClick={handleNavLinkClick}>Запуски</Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link nav-link-custom" to="/contragents" onClick={handleNavLinkClick}>Обучающиеся</Link>
                </li>
              </>
            )}
            
            {/* Navigation items for both roles */}
           {/*} <li className="nav-item">
              <Link className="nav-link nav-link-custom" to="/about" onClick={handleNavLinkClick}>О сервисе</Link>
            </li>*/}  
          </ul>
          <div className="d-flex align-items-center me-3">
            <div className="text-light me-3">
              <div className="d-flex flex-wrap align-items-baseline gap-2">
                <div className="fw-bold">{userData?.name || 'Пользователь'}</div>
                {signedDocsQuota != null && (
                  <span
                    className="small text-white-50"
                    title={`Куплено: ${signedDocsQuota.purchased}, использовано: ${signedDocsQuota.used}, осталось: ${signedDocsQuota.remaining}`}
                  >
                    Подписи: осталось {signedDocsQuota.remaining} / {signedDocsQuota.purchased}
                  </span>
                )}
              </div>
              <div className="small">
                {userData?.office_name || 'Офис не указан'} 
                {userData?.role && (
                  <span className="badge bg-light text-dark ms-2">
                    {userData.role === 'admin' ? 'Администратор' : 'Клиент'}
                  </span>
                )}
              </div>
            </div>
            <button 
              onClick={handleLogout}
              className="btn btn-outline-light"
            >
              Выйти
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;